/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import Media from '../../../../../researcher/blocks/media';

import Item from './nav.item';
import Dropdown from './nav.dropdown';
import { navCss } from './nav.style';
import { PAGES__SHAPE_ITEM, PAGES__SHAPE_ARRAY } from '../../../../../researcher/redux/constants';
import { useNavData } from './useNavData';

const getLastPageID = (pages) =>
  pages.reduce((acc, { id, type }) => (type === 'Page' ? id : acc), '');

export default function NavLarge({ currentPage, hasAnswers, pages, showPreviousButton }) {
  if (!currentPage) return null;
  const { id: pageId } = currentPage;
  const navData = useNavData(pages, pageId);
  const showDropdown =
    navData.pages.filter(({ type }) => type === 'Page').length !==
    pages.filter(({ type }) => type === 'Page').length;
  const lastPageIsVisible = getLastPageID(navData.pages) === getLastPageID(pages);
  const dropdown = showDropdown && <Dropdown pages={pages} pageIndex={navData.pageIndex} />;
  const navIndex = navData.pages.findIndex((page) => page.id === pageId);

  return (
    <Media medium large>
      <nav css={navCss}>
        {lastPageIsVisible && dropdown}
        {navData.pages.map((page, key) => (
          <Item
            hasAnswers={hasAnswers}
            index={navData.start + key}
            navIndex={navData.start + navIndex}
            key={page.id}
            page={page}
            showPreviousButton={showPreviousButton}
            role={page.id}
          />
        ))}
        {!lastPageIsVisible && dropdown}
      </nav>
    </Media>
  );
}

NavLarge.propTypes = {
  currentPage: PAGES__SHAPE_ITEM,
  hasAnswers: PropTypes.bool.isRequired,
  pages: PAGES__SHAPE_ARRAY.isRequired,
};

NavLarge.defaultProps = {
  currentPage: null,
};
